const keptImagesBySrc = new Map();

export function keepImageInMemory(src) {
  if (!src || keptImagesBySrc.has(src)) {
    return;
  }

  const image = new Image();
  image.decoding = 'async';
  keptImagesBySrc.set(src, image);
  image.src = src;

  if (typeof image.decode === 'function') {
    image.decode().catch(() => {});
  }
}

export function keepImagesInMemory(srcList) {
  srcList.forEach(keepImageInMemory);
}
